var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins } from 'vue-property-decorator';
import { SortDirection, SortDirectionPrefix, TableRequestType, TableSelectionAction } from './types';
import TableNonFieldFilters from './table-non-field-filters.vue';
import HeaderCell from './header-cell.vue';
import TableRow from './table-row.vue';
import TablePagination from './table-pagination.vue';
import TableStatus from './table-status.vue';
import SortsMixin from './mixin/sorts';
import TableProperties from './mixin/table-properties';
import SelectedRows from './mixin/selected-rows';
import { downloadBlob } from '@core/helper/download';
import { TableEvent } from '@core/plugin/tc/component/table/enums';
var TCTable = /** @class */ (function (_super) {
    __extends(TCTable, _super);
    function TCTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.TableSelectionAction = TableSelectionAction;
        _this.isLoading = false;
        _this.isDownloadingExcel = false;
        _this.isDownloadingExcelAllObjects = false;
        _this.defaultSorts = [];
        _this.isExcelExportMenuExpanded = false;
        _this.isTooManyRows = false;
        return _this;
    }
    Object.defineProperty(TCTable.prototype, "nonFieldFilters", {
        get: function () {
            var _this = this;
            return this.filters.filter(function (o) { return _this.fields.findIndex(function (f) { return f.name == o.field_name; }) == -1; });
        },
        enumerable: false,
        configurable: true
    });
    TCTable.prototype.getRequestBody = function () {
        var body = new FormData();
        body.append('id', this.id);
        body.append('csrfmiddlewaretoken', this.$getCsrfToken());
        return body;
    };
    TCTable.prototype.initialCleanup = function () {
        this.$el.removeAttribute('fields');
        this.$el.removeAttribute('initial-objects');
        this.$el.removeAttribute('initial-pagination');
    };
    TCTable.prototype.data = function () {
        var search = this.$route.query.search;
        var page = this.$route.query.page;
        return {
            searchText: search != null ? search : '',
            pageNumber: page != null ? page : 1,
        };
    };
    TCTable.prototype.applyInitialSorts = function () {
        if (this.shouldApplyDefaultSort && this.initialSorts.length > 0) {
            this.setSorts(this.initialSorts, 'replace');
        }
    };
    TCTable.prototype.mounted = function () {
        this.initialCleanup();
        this.applyInitialSorts();
        this.bindExternalEvents();
        if (this.settings.max_exportable_rows) {
            this.isTooManyRows = this.pagination.total_object_count > this.settings.max_exportable_rows;
        }
    };
    TCTable.prototype.bindExternalEvents = function () {
        var _this = this;
        window.addEventListener(TableEvent.SetSelected, function (e) {
            if (e.detail.id == _this.id) {
                _this.selected = e.detail.selected;
            }
        });
    };
    TCTable.prototype.getCellStyles = function (field) {
        if (typeof field.width == 'string') {
            return {
                minWidth: field.width,
            };
        }
        else {
            if (field.name == 'email') {
                return {
                    flexGrow: 1,
                    flexShrink: 0,
                };
            }
            return {
                flexGrow: field.width
            };
        }
    };
    TCTable.prototype.onJumpPage = function (pageNumber, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.$router.push({
                            query: __assign(__assign({}, this.$route.query), (_a = {}, _a["".concat(this.prefix, "page")] = pageNumber.toString(), _a))
                        });
                        return [4 /*yield*/, this.update()];
                    case 1:
                        _b.sent();
                        callback();
                        window.scrollTo({
                            // Subtract a safe margin to make sure the non-field filters aren't directly aligned
                            // against the browser window top
                            top: this.$refs.topAnchor.offsetTop - 16,
                            behavior: 'smooth'
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TCTable.prototype.onSort = function (field, direction, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var sorts, newSort, found, i, sort;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        sorts = this.sorts;
                        newSort = "".concat(SortDirectionPrefix[direction]).concat(field.name);
                        found = false;
                        // Iterate over sorts in reverse and remove any previous sorts and append the new sort
                        for (i = sorts.length - 1; i >= 0; i--) {
                            sort = sorts[i];
                            if (sort == field.name || sort == "-".concat(field.name)) {
                                if (direction == SortDirection.None) {
                                    sorts.splice(i, 1);
                                }
                                else {
                                    sorts[i] = newSort;
                                }
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            sorts.push(newSort);
                        }
                        this.$router.push({
                            query: __assign(__assign({}, this.$route.query), (_a = {}, _a["".concat(this.prefix, "sort")] = sorts.join(','), _a))
                        });
                        return [4 /*yield*/, this.update()];
                    case 1:
                        _b.sent();
                        if (callback != null) {
                            callback();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TCTable.prototype.onSearch = function (searchText, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = {
                            query: __assign(__assign({}, this.$route.query), (_a = {}, _a["".concat(this.prefix, "page")] = '1', _a["".concat(this.prefix, "search")] = searchText, _a))
                        };
                        if (this.settings.selection_enabled) {
                            // empty row selections on search
                            data.query["".concat(this.prefix, "selected")] = '';
                        }
                        this.$router.push(data);
                        return [4 /*yield*/, this.update()];
                    case 1:
                        _b.sent();
                        callback();
                        return [2 /*return*/];
                }
            });
        });
    };
    TCTable.prototype.onFilter = function (field, query, callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$router.push({
                            query: __assign(__assign({}, this.$route.query), query)
                        });
                        return [4 /*yield*/, this.update()];
                    case 1:
                        _a.sent();
                        callback();
                        return [2 /*return*/];
                }
            });
        });
    };
    TCTable.prototype.getRequestHeaders = function (requestType) {
        return {
            'X-Requested-With': 'XMLHttpRequest',
            'X-TableRequest': 'true',
            'X-TableRequest-Type': requestType
        };
    };
    TCTable.prototype.getRequestOptions = function (body) {
        return {
            body: body != null ? body : this.getRequestBody(),
            credentials: 'include',
        };
    };
    TCTable.prototype.jsonRequest = function (type, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(location.href, __assign(__assign({}, this.getRequestOptions(body)), { method: 'POST', headers: __assign({}, this.getRequestHeaders(type)) }))];
                    case 1: return [4 /*yield*/, (_a.sent()).json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TCTable.prototype.blobRequest = function (type, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(location.href, __assign(__assign({}, this.getRequestOptions(body)), { method: 'POST', headers: __assign({}, this.getRequestHeaders(type)) }))];
                    case 1: return [4 /*yield*/, (_a.sent()).blob()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TCTable.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.jsonRequest(TableRequestType.UPDATE)];
                    case 1:
                        result = _a.sent();
                        this.filters = result.filters;
                        this.fields = result.fields;
                        this.pagination = result.pagination;
                        this.objects = result.objects;
                        this.defaultSorts = result.sorts;
                        this.layout = result.layout;
                        this.isLoading = false;
                        this.applyInitialSorts();
                        return [2 /*return*/];
                }
            });
        });
    };
    TCTable.prototype.downloadExcel = function (allObjects) {
        if (allObjects === void 0) { allObjects = false; }
        return __awaiter(this, void 0, void 0, function () {
            var body, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // <a> tag doesn't disable click event when disabled
                        if (this.isDownloadingExcel || this.isDownloadingExcelAllObjects) {
                            return [2 /*return*/];
                        }
                        this.isLoading = true;
                        this.isDownloadingExcel = !allObjects;
                        this.isDownloadingExcelAllObjects = allObjects;
                        body = this.getRequestBody();
                        if (allObjects) {
                            body.append('all-objects', '1');
                        }
                        return [4 /*yield*/, this.blobRequest(TableRequestType.DOWNLOAD_EXCEL, body)];
                    case 1:
                        result = _a.sent();
                        this.isLoading = false;
                        downloadBlob(result, this.settings.excel_filename);
                        this.isDownloadingExcel = false;
                        this.isDownloadingExcelAllObjects = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    TCTable.prototype.onRowSelected = function (_a) {
        var isSelected = _a.isSelected, object = _a.object;
        var pk = object._pk_;
        var selected = this.selected;
        if (selected.indexOf(pk) > -1) {
            selected.splice(selected.indexOf(pk), 1);
        }
        else {
            selected.push(pk);
        }
        this.selected = selected;
    };
    TCTable = __decorate([
        Component({
            mixins: [SortsMixin, TableProperties, SelectedRows],
            components: { TableNonFieldFilters: TableNonFieldFilters, HeaderCell: HeaderCell, TableRow: TableRow, TablePagination: TablePagination, TableStatus: TableStatus }
        })
    ], TCTable);
    return TCTable;
}(Mixins(SortsMixin, TableProperties, SelectedRows)));
export default TCTable;
